import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Typography,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Fab,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import theme from '../../../theme';
import MetierModal from '../FormModal/metierModal';
import useSessionContext from '../../../sessions/useSessionContext';
import FormConfirmPartnerMetierDelete from '../../PartnerMetiersConfimationBox';

const useStyles = makeStyles((theme) => ({
  rootCard: {
    width: '100%',
  },
  profileTabTitle: {
    '& span:first-child': {
      fontWeight: 600,
      fontSize: '1.25rem',
      color: '#E5087E',
    },
    '& span:last-child': {
      fontWeight: 500,
      fontSize: '1.05rem',
    },
  },
  serviceTitle: {
    '& span': {
      fontSize: '1.1rem',
    },
  },
  contactBtn: {
    textAlign: 'center',
    backgroundColor: theme.palette.primary.main,
    color: '#e5087e',
    cursor: 'pointer',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 16,
    margin: 0,
    transition: 'color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
}));

const PartnerMetiers = (props) => {
  const { user, refreshUserData } = useSessionContext();
  const [show, setShow] = useState(false);
  const openModalAddMetier = () => setShow(true);
  const closeModalAddMetier = () => setShow(false);
  const classes = useStyles(theme);
  const [partnerMetiers, setPartnerMetiers] = useState([]);

  useEffect(() => {
    setPartnerMetiers(user.partner_metiers);
  }, [user]);

  return (
    <Grid container>
      <Card square className={classes.rootCard} elevation={0} variant="outlined">
        <Grid container alignItems="center">
          <Grid item xs={10}>
            <CardHeader
              title="Métiers"
              subheader="Sélectionner le(s) métier(s) pour les lequels vous recherchez des offres de stages"
              className={classes.profileTabTitle}
            />
          </Grid>
          <Grid
            item
            xs={2}
            style={{
              display: 'flex',
              justifyContent: 'center',
              padding: '20px 0',
            }}
          >
            <Fab
              id="addMetier"
              color="secondary"
              aria-label="add"
              onClick={() => {
                refreshUserData();
                openModalAddMetier();
              }}
            >
              <AddIcon />
            </Fab>
          </Grid>
        </Grid>
      </Card>
      <Card className={classes.rootCard} square variant="outlined">
        {partnerMetiers.map((metier, ind) => (
          <Grid key={ind} alignItems="center" container>
            <Grid item xs={10}>
              <CardHeader title={metier.name} className={classes.serviceTitle} />
            </Grid>
            <Grid
              item
              xs={2}
              style={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <FormConfirmPartnerMetierDelete partnerMetier={metier} />
            </Grid>
          </Grid>
        ))}
      </Card>
      <MetierModal
        closeModal={closeModalAddMetier}
        refreshUserData={refreshUserData}
        show={show}
        partnerMetiers={partnerMetiers}
      />
    </Grid>
  );
};
export default PartnerMetiers;
